'use strict'

import ApiClient from './ApiClient'

export default class BcardRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 自分の名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchBox (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }

    data = {
      search_target: 'my',
      free_word: data.free_word || '',
      name: data.name || '',
      corporate_name: data.corporate_name || '',
      dept_post: data.dept_post || '',
      zipcode: data.zipcode || '',
      address: data.address || '',
      tel: data.tel || '',
      fax: data.fax || '',
      mail: data.mail || '',
      memo: data.memo || '',
      keywords: data.keywords || '',
      openflag: data.openflag || [],
      tags: data.tags || [],
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || '',
      ex_location: data.ex_location || '',
      ex_trigger: data.ex_trigger || '',
      in_introducer: data.in_introducer || [],
      out_introducer: data.out_introducer || [],
      age: data.age || '',
      display_mode: data.display_mode || ''
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * すべての名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchAll (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }

    data = {
      search_target: 'all',
      free_word: data.free_word || '',
      name: data.name || '',
      corporate_name: data.corporate_name || '',
      dept_post: data.dept_post || '',
      zipcode: data.zipcode || '',
      address: data.address || '',
      tel: data.tel || '',
      fax: data.fax || '',
      mail: data.mail || '',
      memo: data.memo || '',
      keywords: data.keywords || '',
      openflag: data.openflag || [],
      tags: data.tags || [],
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || '',
      exchangers: data.exchangers || [],
      ghost_exchangers: data.ghost_exchangers || '',
      ex_location: data.ex_location || '',
      ex_trigger: data.ex_trigger || '',
      in_introducer: data.in_introducer || [],
      out_introducer: data.out_introducer || [],
      age: data.age || '',
      display_mode: data.display_mode || ''
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * お気に入り名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchFav (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }

    data = {
      search_target: 'fav',
      free_word: data.free_word || '',
      name: data.name || '',
      corporate_name: data.corporate_name || '',
      dept_post: data.dept_post || '',
      zipcode: data.zipcode || '',
      address: data.address || '',
      tel: data.tel || '',
      fax: data.fax || '',
      mail: data.mail || '',
      memo: data.memo || '',
      keywords: data.keywords || '',
      openflag: data.openflag || [],
      tags: data.tags || [],
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || '',
      ex_location: data.ex_location || '',
      ex_trigger: data.ex_trigger || '',
      in_introducer: data.in_introducer || [],
      out_introducer: data.out_introducer || [],
      age: data.age || '',
      display_mode: '0' // 最新固定
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 最近見た名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchAcc (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }

    data = {
      search_target: 'acc'
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 画像未登録名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchNoimage (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }

    data = {
      search_target: 'noimage',
      search_target_noimage: data.search_target_noimage || '',
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || ''
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 名寄せ候補名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchNonjudged (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }

    data = {
      search_target: 'nonjudged'
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 名刺履歴検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchHistory (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }

    data = {
      search_target: 'all',
      display_mode: '1',
      sid_person: data.sid_person
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 複数の名刺IDを指定して、関連する名刺または名刺人物情報を一括で削除します。
   * @param {array} sid_bcards
   * @returns {*}
   */
  bulkDelete (sid_bcards) {
    return ApiClient().post(`/bcards/delete`, { sid_bcards })
  }

  /**
   * 簡易的な名刺情報を取得します。（名刺人物IDが欲しい場合など）
   * @param {string|int} id 名刺ID
   * @param {bool} isMgmt 管理モードフラグ
   */
  get (id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/bcards/${id}`, { params })
  }

  /**
   * 名刺情報を修正します。
   * @param {string|int} id 名刺ID
   * @param {object} formData
   * @param {bool} isMgmt 管理モードフラグ
   */
  put (id, formData, isMgmt) {
    formData.append('_method', 'PUT')

    return ApiClient().post(`/bcards/${id}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
      params: this.setMgmtParam(isMgmt)
    })
  }

  /**
   * 名刺に紐づく画像一覧を取得する
   * @param id 名刺ID
   * @param isMgmt 管理モードフラグ
   */
  getImages (id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/bcards/${id}/images`, { params })
  }

  /**
   * 参照履歴登録処理を行います。
   * @param {string|int} id 名刺ID
   */
  touch (id) {
    return ApiClient().put(`/bcards/${id}/history`)
  }

  /**
   * 名刺情報をCSVファイルにエクスポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  postExport (formData) {
    return ApiClient().post(`/bcards/export`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 名刺情報エクスポートファイルをダウンロードします。
   * @param {object} options
   * @returns {*}
   */
  getExport (options) {
    return ApiClient().get(`/bcards/export`, options)
  }

  /**
   * 名刺情報エクスポートの処理結果を取得する。
   * @returns {*}
   */
  getExportResult () {
    return ApiClient().get(`/bcards/export-result`)
  }

  /**
   * 名刺情報エクスポートを停止する。（キャンセルファイルを作成する。）
   * @returns {*}
   */
  cancelExport () {
    return ApiClient().post(`/bcards/export-cancel`)
  }

  /**
   * 名刺人物のタグを一括で更新します。
   * @param {array} sid_bcards チェックしたIDだけ対象にする場合、必須
   * @param {object} conds 全ページ一括処理（検索する）場合、必須
   *    - search_target（必須）
   *    - free_word（任意）
   *    - ...
   * @param {array} sid_tags 付け替えるタグのID
   * @param {string} method 'result' 'add' 'remove'
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  buldChangeTags (sid_bcards, conds, sid_tags, method, isMgmt) {
    const params = this.setMgmtParam(isMgmt)

    let data = {}
    if (sid_bcards) {
      data.sid_bcards = sid_bcards
    }
    else if (conds) {
      Object.assign(data, conds)

      // 【複数選択の項目】
      // IDだけ抜き出して上書きする
      // 社内紹介者
      Object.assign(data, {in_introducer: conds.in_introducer ? conds.in_introducer.map(user => user.id) : []})
      // 社外紹介者
      Object.assign(data, {out_introducer: conds.out_introducer ? conds.out_introducer.map(person => person.id) : []})
      // タグ
      Object.assign(data, {tags: conds.tags ? conds.tags.map(tag => tag.id) : []})

      // 「削除されたユーザーが交換した名刺を検索する」ときは、交換者の条件を消す
      if (conds.ghost_exchangers !== '1') { // TODO this.app_flag.ON
        // 名刺交換者
        Object.assign(data, {exchangers: conds.exchangers ? conds.exchangers.map(exchanger => exchanger.id) : []})
      }
    }
    if (sid_tags) {
      data.sid_tags = sid_tags
    }
    data.method = method

    return ApiClient().post(`/bcards/tags`, data, { params })
  }

  /**
   * 名刺情報の一括更新処理を行い、新しい名刺を作成します。
   * @param {array} sid_bcards
   * @param {string} exchange_date
   * @param {object} bcard 名刺情報 指定したカラムだけ（例え空文字でも）更新する
   * @param {boolean} isMgmt
   * @returns {*}
   */
  buldPost (sid_bcards, exchange_date, bcard, isMgmt) {
    const params = this.setMgmtParam(isMgmt)

    let data = {
      sid_bcards,
      exchanges: { exchange_date }
    }
    Object.assign(data, bcard)

    return ApiClient().post(`/bcards/bulk`, data, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/BcardRepository.js